/**
* class HSN.Topology
*
* Parses and Builds urls from shop and search topologies.
**/
HSN.Topology = function (deptId, facets, slug) {
    this.deptId = deptId;
    this.facets = [].concat(facets || []);
    this.slug = slug;
}

// Static functions
HSN.Topology.FromLocation = function (location) {
    var params = HSN.Topology.getQueryParams(location);
    var pathParts = location.pathname.split('/');
    var lastPathPart = pathParts.pop() || pathParts.pop(); // handle trailing slash.
    var slug = pathParts.pop();
    var isSearch = lastPathPart.toLowerCase() === 'search';
    var deptId = null;
    var facets = [];

    if (isSearch) {
        // Ex: https://wwwlocal.hsn.com/search?store=&sort=featured&query=blue+dress&facet=12215&facet=13243&facet=7263&facet=6511
        deptId = params["store"] || "";
        facets = [].concat(params["facet"] || []);
    } else {
        // Ex: https://wwwlocal.hsn.com/shop/fashion/fa-5544-6751-6751-6752?sort=featured&view=all
        var topologyParts = lastPathPart.split("-");
        var hasDept = !!topologyParts[0].charAt(0).match(/[a-z]/i);

        if (hasDept) {
            deptId = topologyParts[0];
            facets = topologyParts.slice(1) || [];
        } else {
            facets = topologyParts;
        }

        facets = facets.concat(params["facet"] || []);
    }

    return new HSN.Topology(deptId, facets, slug);
}

HSN.Topology.FromUrl = function(url) {
    let location = document.createElement('a');
    location.href = url;

    return HSN.Topology.FromLocation(location);
}

HSN.Topology.FromObject = function(obj) {
    return new HSN.Topology(obj.deptId, obj.facets || [], obj.slug);
}

// Instance functions
HSN.Topology.prototype = {
    /**
        * @returns a url prepended with the baseUrl and slug
        */
    toUrl: function (baseUrl, withSlug, buildAsQueryString) {
        var buildAsQueryString = buildAsQueryString === true;
        var url = baseUrl;

        url += withSlug ? "/" + this.slug : "";

        url += this.toUrlPath(buildAsQueryString);

        return url;
    },

    /**
        * @returns {string} the topology portion of the url
        */
    toUrlPath: function(buildAsQueryString) {
        var url = "";

        if (buildAsQueryString) {
            url += "?store=" + (this.deptId || "")
                + "&facet=" + this.facets.join("&facet=");
        } else {
            url += "/";
            if (this.deptId) {
                url += [this.deptId].concat(this.facets).join('-');
            } else {
                if (this.facets.length > 0) {
                    url += this.facets.join('-');
                } else {
                    url += "-";
                }
            }
        }

        return url;
    },

    /**
        * Try to add a facet
        * @param {string} id - the facet id
        * @returns {bool} false if already added
        */
    addFacet: function (id) {
        var index = this.facets.indexOf(id);
        if (index !== -1) return false;

        this.facets.push(id);
        return true;
    },

    /**
        * Try to remove a facet
        * @param {string} id - the facet id
        * @returns {bool} false if already removed
        */
    removeFacet: function(id) {
        var index = this.facets.indexOf(id);
        if(index === -1) return false;

        this.facets.splice(index, 1);
        return true;
    },

    /**
        * Clone this topology
        */
    clone: function () {
        return new HSN.Topology(this.deptId, this.facets, this.slug, this.buildAsQueryString, this.query);
    }
};

// Helper functions
HSN.Topology.getQueryParams = function(location) {
    var params = {};
    var parts = location.search.replace("?", "").split('&').filter(p => p);

    for (var i = 0; i < parts.length; i++) {
        var pieces = parts[i].split("=");
        var key = pieces[0];
        if (pieces[1] !== "") {
            if (params[key]) {
                params[key] = [].concat(params[key], decodeURIComponent(pieces[1]));
            } else {
                params[key] = decodeURIComponent(pieces[1]);
            }
        }
    }

    return params;
}


// WEBPACK FOOTER //
// ./assets/js/HSN/Topology.js